<div class="calendar-container">
    <header class="calendar-header">
        <p class="calendar-current-date">{{ months[month] }} {{ year }}</p>
        <div class="calendar-navigation">
            <span (click)="changeMonth(-1)" class="material-symbols-rounded">
                <mat-icon>chevron_left</mat-icon>
            </span>
            <span (click)="changeMonth(1)" class="material-symbols-rounded">
                <mat-icon>chevron_right</mat-icon>
            </span>
        </div>
    </header>

    <div class="calendar-body">
        <ul class="calendar-weekdays">
            @for(day of weekDays; track day){
            <li>{{ day }}</li>
            }
        </ul>
        <ul class="calendar-dates">
            @for(dayObj of daysInMonth; track dayObj){
            <li [class]="dayObj.class" [class.disabled-selection]="dayObj.day > 0 && isSelectionDisabled(dayObj.day)"
                (click)="dayObj.day > 0 && selectDay(dayObj.day)">
                {{ dayObj.day > 0 ? dayObj.day : '' }}
            </li>
            }
        </ul>
    </div>
</div>